module.exports = __webpack_public_path__ + "img/desc5.4e3ba085.png";